import React from 'react';
import Section from '../common/Section';

const phases = [
  { title: 'Stabilize', days: 'Days 1 to 90' },
  { title: 'Understand', days: '91 to 180' },
  { title: 'Rebuild', days: '181 to 270' },
  { title: 'Sustain', days: '271 to 365' },
];

const PhasesSection = () => (
  <Section id="phases" background="white" padding="md" panel={false} className="pt-2" style={{ backgroundColor: 'var(--cream-canvas)' }}>
    <div
      className="max-w-6xl mx-auto rounded-[28px] border p-6 sm:p-8 md:p-10"
      style={{
        backgroundColor: 'var(--surface-soft-2)',
        borderColor: 'rgba(31, 42, 36, 0.08)',
        boxShadow: '0 18px 38px rgba(20, 48, 36, 0.08)',
      }}
    >
      <p className="text-xs font-bold tracking-[0.18em]" style={{ color: 'var(--brand-green-deep)' }}>
        THE 365 DAY JOURNEY
      </p>
      <h2 className="mt-3 text-2xl sm:text-3xl font-extrabold" style={{ color: 'var(--text-primary)' }}>
        A year organized into seasons of growth
      </h2>

      <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {phases.map((phase) => (
          <div
            key={phase.title}
            className="rounded-2xl border p-4"
            style={{ backgroundColor: 'var(--surface-card)', borderColor: 'rgba(31, 42, 36, 0.08)' }}
          >
            <p className="text-sm font-extrabold" style={{ color: 'var(--brand-green-deep)' }}>
              {phase.title}
            </p>
            <p className="mt-1 text-sm" style={{ color: 'var(--text-muted)' }}>
              {phase.days}
            </p>
          </div>
        ))}
      </div>
    </div>
  </Section>
);

export default PhasesSection;
